import { reactive } from 'vue'

// 创建全局音乐播放器状态
const musicState = reactive({
  musicList: [],
  currentIndex: 0,
  isPlaying: false,
  currentTime: 0,
  duration: 0,
  volume: 0.5,
  isInitialized: false
})

// 音乐播放器管理类
class MusicPlayerManager {
  constructor() {
    this.audio = null
    this.lottieInstance = null
    this.isInitialized = false
    this.listeners = new Map() // 存储事件监听器
  }

  // 添加事件监听器
  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, [])
    }
    this.listeners.get(event).push(callback)
  }

  // 移除事件监听器
  off(event, callback) {
    if (this.listeners.has(event)) {
      const callbacks = this.listeners.get(event)
      const index = callbacks.indexOf(callback)
      if (index > -1) {
        callbacks.splice(index, 1)
      }
    }
  }

  // 触发事件
  emit(event, data) {
    console.log('🎵 触发事件:', event, data, '监听器数量:', this.listeners.has(event) ? this.listeners.get(event).length : 0);
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach(callback => {
        callback(data)
      })
    }
  }

  // 初始化音频播放器
  init(audioElement) {
    if (this.isInitialized) return
    
    this.audio = audioElement
    this.isInitialized = true
    
    // 绑定音频事件
    this.audio.ondurationchange = () => {
      musicState.duration = this.audio.duration
    }
    
    this.audio.ontimeupdate = () => {
      musicState.currentTime = this.audio.currentTime
    }
    
    this.audio.onended = () => {
      this.next()
    }
    
    this.audio.onerror = () => {
      console.log('音频加载出错')
    }
  }

  // 设置音乐列表
  setMusicList(list) {
    musicState.musicList = list
    if (list.length > 0 && !this.audio?.src) {
      this.loadMusic(0)
    }
  }

  // 加载音乐
  loadMusic(index) {
    if (!musicState.musicList[index]) return
    
    musicState.currentIndex = index
    if (this.audio) {
      console.log('🎵 加载音乐:', musicState.musicList[index].url_name);
      this.audio.src = musicState.musicList[index].url_name
      // 确保不会自动播放
      this.audio.pause()
      this.audio.currentTime = 0
    }
  }

  // 播放/暂停
  togglePlay() {
    if (!this.audio) return
    
    if (musicState.isPlaying) {
      this.audio.pause()
      musicState.isPlaying = false
      // 发出暂停事件
      this.emit('musicPlayerPause', { isPlaying: false })
    } else {
      this.audio.play()
      musicState.isPlaying = true
      // 发出播放事件，通知其他音频停止
      this.emit('musicPlayerPlay', { isPlaying: true })
    }
  }

  // 上一首
  previous() {
    const newIndex = musicState.currentIndex > 0 
      ? musicState.currentIndex - 1 
      : musicState.musicList.length - 1
    this.loadMusic(newIndex)
    
    if (musicState.isPlaying) {
      this.audio.play()
      // 发出播放事件，通知其他音频停止
      this.emit('musicPlayerPlay', { isPlaying: true })
    }
  }

  // 下一首
  next() {
    const newIndex = musicState.currentIndex < musicState.musicList.length - 1 
      ? musicState.currentIndex + 1 
      : 0
    this.loadMusic(newIndex)
    
    if (musicState.isPlaying) {
      this.audio.play()
      // 发出播放事件，通知其他音频停止
      this.emit('musicPlayerPlay', { isPlaying: true })
    }
  }

  // 设置播放位置
  setCurrentTime(time) {
    if (this.audio) {
      this.audio.currentTime = time
    }
  }

  // 设置音量
  setVolume(volume) {
    if (this.audio) {
      this.audio.volume = volume
      musicState.volume = volume
    }
  }

  // 获取当前音乐信息
  getCurrentMusic() {
    return musicState.musicList[musicState.currentIndex] || null
  }
}

// 创建全局实例
const musicPlayerManager = new MusicPlayerManager()

export { musicState, musicPlayerManager }
